'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/slicedToArray");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _objectSpread = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectSpread2");

var pSome = require('p-some');

var PCancelable = require('p-cancelable');

module.exports = function (iterable, options) {
  var anyCancelable = pSome(iterable, _objectSpread(_objectSpread({}, options), {}, {
    count: 1
  }));
  return PCancelable.fn( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(onCancel) {
      var _yield$anyCancelable, _yield$anyCancelable2, value;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              onCancel(function () {
                anyCancelable.cancel();
              });
              _context.next = 3;
              return anyCancelable;

            case 3:
              _yield$anyCancelable = _context.sent;
              _yield$anyCancelable2 = _slicedToArray(_yield$anyCancelable, 1);
              value = _yield$anyCancelable2[0];
              return _context.abrupt("return", value);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }())();
};

module.exports.AggregateError = pSome.AggregateError;